const caretakerCardPath = (caretakerId: string) => `/caretaker/card/${caretakerId}`
const caretakerLocationPath = () => `/caretaker/location`
const getRecommendationBasicDataPath = (serviceId: string) => `/recommendation/${serviceId}/basic-data`
const getRecommendationReviewsPath = (caretakerId: string) => `/recommendation/${caretakerId}/reviews`
const getLongTermRecommendacionPath = (serviceId: string) =>
  `particular-long-term-recommendation/${serviceId}/basic-data`
const getNewBroadcastServicePath = () => `/new-broadcast-service`
const getOnSessionPaymentClientSecretIdPath = (requestId: string) => `/payment/${requestId}/on-session`
const getOffSessionPaymentClientSecretIdPath = (requestId: string) => `/payment/${requestId}/setup`
const getNewPaymentMethodSetupPath = () => `/payment/new-payment-method-setup`
const getOneTimePremiumPaymentClientSecretIdPath = () => '/one-time-premium-subscription-payment'
const getProSubscriptionSignUpPaymentPath = () => '/pro-subscription-sign-up-payment'
const getCheckProCouponValidityPath = () => '/pro-coupon/validate'
const getCustomerDetailsInfoPremiumPath = () => '/subscription-details'
const getCaretakerDetailsInfoProPath = () => '/pro-subscription-details'
const getCancelProSubscriptionPath = () => '/pro-subscription/cancel'
const getProSubscriptionUpdatePaymentMethodPath = () => '/pro-subscription/update-payment-method'
const getCreateCouponPath = () => '/premium-coupon/create'
const getCheckCouponValidityPath = () => '/premium-coupon/validate'
const getRecommendationPaymentTokenPath = (requestId: string) => `/payment/${requestId}/authorize`
const getCheckoutPaymentDataPath = (caretakerId: string) => `/payment/new-service/authorize/${caretakerId}`
const getPaymentBasicDataPath = (requestId: string) => `/payment/${requestId}/basic-data`
const getExtraChargePath = (requestId: string) => `/extra-charge/${requestId}`
const getAccompanimentsSearchServiceListPath = () => '/institutional-no-booked-services'
const getAccompanimentsBookedServiceListPath = () => '/institutional-booked-services'
const getAccompanimentsHistoryServiceListPath = () => '/institutional-historical-services'
const getProfessionalServiceSearchServiceListPath = () => '/institutional-long-term-no-booked-services'
const getProfessionalServiceHistoryServiceListPath = () => '/institutional-long-term-historical-services'
const getCallCenterSearchServiceListPath = () => '/call-center/no-booked-services'
const getCallCenterBookedServiceListPath = () => '/call-center/booked-services'
const getCallCenterHistoricalServiceListPath = () => '/call-center/historical-services'
const getCaretakerOffersListPath = () => '/caretaker/offers'
const caretakerAcceptServicePath = serviceId => `/service/accept/${serviceId}`
const caretakerRejectServicePath = serviceId => `/service/reject/${serviceId}`
const caretakerServiceDetailsPath = (serviceId: string) => `/service/details/${serviceId}`
const caretakerExternalReviewPath = (userId: string) => `/user/${userId}/caretaker-review`
const getCaretakersLocationPath = () => `/located-caretakers`
const getSelectedCaretakerDetailsPath = () => `/selected-caretakers-details`
const getSendCaretakerPresentationMessagePath = (serviceId: string) => `/request/presentation_message/${serviceId}`
const userProfileImagePath = (userId: string) => `/user/profile-image/${userId}`
const caretakerLikeActionPath = (caretakerId: string) => `/caretaker/like/${caretakerId}`
const caretakerShareActionPath = (caretakerId: string) => `/caretaker/share/${caretakerId}`
const viewCaretakerCandidaturePath = (requestId: string) => `/request/view/${requestId}`
const getResidentsListPath = () => `/residence/basic-residents`
const getDetailedResidentsListPath = () => `/residence/detailed-residents`
const getResidenceRecommendationServicePath = () => `/recommendation-service/residence`
const getCalculateBudgetPath = caretakerId => `/calculate-budget/${caretakerId}`
const getNewLeadPath = () => `/new-lead`
const getCaretakerImagesReviewPath = () => '/caretaker-images-review'
const acceptCaretakerImage = (userId: string) => `/caretaker-image/accept/${userId}`
const rejectCaretakerImage = (userId: string) => `/caretaker-image/reject/${userId}`
const getIdentityVerificationUrlPath = () => `/verification/identity`
const getIdentityVerificationDataPath = () => `/caretaker/identity-verification-data`
const getCandidatureDetailsPath = (requestId: string) => `/candidature/details/${requestId}`
const unsubscribeEmailsPath = (userId: string) => `/caretaker/unsubscribe-from-emails/${userId}`

export const apiRouter = {
  caretakerCardPath,
  caretakerLocationPath,
  getRecommendationBasicDataPath,
  getRecommendationReviewsPath,
  getLongTermRecommendacionPath,
  getNewBroadcastServicePath,
  getOnSessionPaymentClientSecretIdPath,
  getOffSessionPaymentClientSecretIdPath,
  getCreateCouponPath,
  getCheckProCouponValidityPath,
  getCheckCouponValidityPath,
  getRecommendationPaymentTokenPath,
  getCheckoutPaymentDataPath,
  getPaymentBasicDataPath,
  getExtraChargePath,
  getOneTimePremiumPaymentClientSecretIdPath,
  getProSubscriptionSignUpPaymentPath,
  getProSubscriptionUpdatePaymentMethodPath,
  getNewPaymentMethodSetupPath,
  getCustomerDetailsInfoPremiumPath,
  getCaretakerDetailsInfoProPath,
  getCancelProSubscriptionPath,
  getAccompanimentsSearchServiceListPath,
  getAccompanimentsBookedServiceListPath,
  getAccompanimentsHistoryServiceListPath,
  getProfessionalServiceSearchServiceListPath,
  getProfessionalServiceHistoryServiceListPath,
  getCallCenterSearchServiceListPath,
  getCallCenterBookedServiceListPath,
  getCallCenterHistoricalServiceListPath,
  getCaretakerOffersListPath,
  caretakerAcceptServicePath,
  caretakerRejectServicePath,
  caretakerServiceDetailsPath,
  caretakerExternalReviewPath,
  getCaretakersLocationPath,
  getSelectedCaretakerDetailsPath,
  getSendCaretakerPresentationMessagePath,
  userProfileImagePath,
  caretakerLikeActionPath,
  caretakerShareActionPath,
  viewCaretakerCandidaturePath,
  getResidentsListPath,
  getDetailedResidentsListPath,
  getResidenceRecommendationServicePath,
  getCalculateBudgetPath,
  getNewLeadPath,
  getCaretakerImagesReviewPath,
  acceptCaretakerImage,
  rejectCaretakerImage,
  getIdentityVerificationUrlPath,
  getIdentityVerificationDataPath,
  getCandidatureDetailsPath,
  unsubscribeEmailsPath,
}



// WEBPACK FOOTER //
// ./src/domain/model/apiRouter.ts